import React,{ useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from './Navigation';

function Routes() {
    const [routes, setRoutes] = useState([]);

    useEffect(() => {
        document.title = 'Sydney Ferris - Courses';
        getRoutes();
    }, []);

    const getRoutes = () => {
      setRoutes([
        {
          route: 'dashboard',
          title: 'Dashboard',
          description: 'Main dashboard view',
          completed: false
        },

        {
          route: 'database',
          title: 'Database Dashboard',
          description: 'Database management interface',
          completed: false
        },
        {
          route: 'finance',
          title: 'Personal Finance',
          description: 'Personal finance dashboard',
          completed: false
        },
        {
          route: 'f1-charts',
          title: 'F1 Charts',
          description: 'Formula 1 data visualization',
          completed: false
        },
        {
          route: 'f1-pitstops',
          title: 'F1 Pitstops',
          description: 'Summary of F1 Pitstops over 70 years',
          completed: false
        }
      ]);
    };

  return (
    <div className="theme-bg py-12">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className='flex justify-end px-8 py-4'>
        </div>
        <div className="mx-auto max-w-2xl sm:text-center">
          <h2 className="text-3xl font-bold tracking-wider theme-primary sm:text-4xl">Get All your Routes here</h2>
          <p className="mt-6 text-lg leading-8 theme-secondary">
          Checkout all the routes available
          </p>
        </div>
        {routes.map(route => (
          <div key={route.route || 'home'} className="mx-auto max-w-2xl rounded-3xl ring-1 ring-gray-200 sm:mt-2 lg:mx-0 lg:flex lg:max-w-none">
            <div className="p-4 sm:p-10 lg:flex-auto">
              <h3 className="text-2xl font-bold tracking-tight theme-primary">{route.title}</h3>
              <p className="mt-1 text-base leading-7 theme-secondary">
              {route.description}
              </p>
            </div>
            <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:flex-shrink-0">
              <div className="rounded-2xl theme-bg-secondary py-10 text-center ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center">
                  <Link to={route.route ? `/${route.route}/` : '/'}
                    className={`block w-full rounded-md px-3 py-2 text-center text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                      route.completed
                        ? 'bg-green-600 hover:bg-green-500 focus-visible:outline-green-600'
                        : 'bg-red-600 hover:bg-red-500 focus-visible:outline-red-600'
                    }`}
                  >
                    View Route
                  </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Routes